import { render } from "./HorizentalView.vue?vue&type=template&id=3b5ef09a&scoped=true"
import script from "./HorizentalView.vue?vue&type=script&lang=js"
export * from "./HorizentalView.vue?vue&type=script&lang=js"

import "./HorizentalView.vue?vue&type=style&index=0&id=3b5ef09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5ef09a"]])

export default __exports__